export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9248.58b68115.jpg";